import { join } from 'path'
import { resolve, relative, contains } from 'webmango-utils/path'
import ParseMS from 'parse-ms'

const MAX_ID_LENGTH = 15

export default function FileJob (opts = {}, { localRoot, remoteRoot }, body) {
  let {
    id,
    path,
    filename = `${id}.sh`
  } = opts

  if (typeof path !== 'string') {
    throw new TypeError(`exec: path – expected string got (${typeof path}): ${path}`)
  }

  opts = Object.assign({}, opts, {
    filename
  })

  if (contains(localRoot, path)) {
    path = relative(localRoot, path)
  } else if (contains(remoteRoot, path)) {
    path = relative(remoteRoot, path)
  }

  const localDir = resolve(localRoot, path)
  const remoteDir = resolve(remoteRoot, path)

  const job = Job(opts, body)
  return Object.assign({}, job, {
    localDir,
    remoteDir,
    localPath: join(localDir, job.filename),
    remotePath: join(remoteDir, job.filename),
    localOutput: join(localDir, job.output),
    localError: join(localDir, job.error)
  })
}

export function Job (opts, body = () => '') {
  let {
    id,
    path = '',
    workingPath = path,
    results = '',
    output = join(results, `${id}.o`),
    error = join(results, `${id}.e`),
    cpus = 1,
    walltime = '00:00:01',
    project = 'none',
    queue = 'normal',
    mem = 1,
    memUnit = 'GB',
    jobfs = 0,
    jobfsUnit = 'GB',
    server = 'raijin'
  } = opts

  if (id.length > MAX_ID_LENGTH) throw new Error(`job id (name) too long`)

  if (queue === 'none') queue = undefined
  if (project === 'none') project = undefined

  const job = Object.assign({}, opts, {
    id,
    path,
    workingPath,
    output,
    error,
    cpus,
    mem,
    walltime,
    project,
    queue,
    memUnit,
    jobfs,
    server
  })

  job.header = clean(`
    #!/bin/bash -l
    #PBS -N ${id}
    #PBS -W umask=027
    #PBS -o ${output}
    #PBS -e ${error}
    #PBS -l wd
    #PBS -l storage=gdata/fx2+scratch/w09+gdata/w09
    #PBS -l mem=${mem}${memUnit},ncpus=${cpus}
    ${jobfs ? `#PBS -l jobfs=${jobfs}${jobfsUnit}` : ''}
    #PBS -l walltime=${toHHMMSS(walltime)}
    ${project ? `#PBS -P ${project}` : ''}
    ${queue ? `#PBS -q ${queue}` : ''}
  `.trim().split(/\n+/g).map(s => s.trim()).filter(Boolean).join('\n'))

  job.body = clean(body(job))
  job.script = [job.header, job.body].filter(Boolean).join('\n') + '\n'

  return job
}

const clean = (s = '') => {
  let lines = s.split('\n')
  const indent = lines.reduce((min, line) => {
    const lineIndent = line.length - line.replace(/^\s+/, '').length
    return Math.min(min, lineIndent)
  }, Infinity)
  if (indent && Number.isFinite(indent)) {
    lines = lines.map(line => line.slice(indent))
  }
  return lines.join('\n').trim() + '\n'
}

function toHHMMSS (value) {
  if (typeof value === 'string') return `${value}:00`
  const v = ParseMS(Number(value))
  const seconds = Math.round((v.milliseconds + v.seconds * 1000) / 1000)
  let hours = v.hours + (v.days * 24)
  let minutes = v.minutes + Math.round(seconds / 60)
  if (minutes < 10) minutes = `0${minutes}`
  if (hours < 10) hours = `0${hours}`
  return `${hours}:${minutes}:00`
}



// WEBPACK FOOTER //
// ../pbs-api/job.js